

export const createAccountStyles = {
    mainContainer:{
        color: 'gray',
        height: '100vh',
    },
    formContainer:{
        background: '#ffffff',
        borderRadius: ".8rem",
        padding: '2rem',
        marginBottom: "1.5rem"
    },
    formControl:{
        width: '100%',
        mb: 6,
    },

    btn:{
        width:'100%'
    }
}